import deserialize from 'app/utils/deserialize'
import FormErrors from 'app/utils/form_errors'
import { fetch, update } from 'app/utils/data'

export default {
  namespaced: true,

  state: {
    item: null
  },

  mutations: {
    passwordResetFetched(state, { passwordReset }) {
      state.item = passwordReset
    },

    resetState(state) {
      state.item = null
    }
  },

  actions: {
    fetchPasswordReset({ commit }, { resetPasswordToken }) {
      return new Promise((resolve, reject) => {
        fetch({
          url: '/api/password-resets',
          type: 'password-reset',
          params: {
            'filter[token]': resetPasswordToken
          }
        })
          .then((response) => {
            deserialize(response.data).then((passwordReset) => {
              commit('passwordResetFetched', { passwordReset })
              resolve()
            })
          })
          .catch((_error) => {
            reject()
          })
      })
    },

    resetPassword({ commit, state }, changes) {
      return new Promise((resolve, reject) => {
        update({
          url: `/api/password-resets/${state.item.id}`,
          type: 'password-reset',
          changes,
          record: state.item
        })
          .then((response) => {
            commit('resetState')
            resolve()
          })
          .catch((error) => {
            if (error.response.status === 404) {
              reject(new FormErrors([{ detail: 'Something went wrong.' }]))
            } else {
              reject(new FormErrors(error.response.data.errors))
            }
          })
      })
    }
  }
}
